import styled from "styled-components";
import * as zero from '@zero/design-tokens/build/js/variables'
import { Breakpoints } from "@/shared/styles/breakpoints";

export const Container = styled.div`
    box-sizing: border-box;
    font: normal normal normal ${zero.ZrFontSizeNano} ${zero.ZrFontFamilyDigitalRegular};
    display: flex;
    align-items: center;      
        
    flex: 0 auto;

    h6 {
        font: normal normal 300 ${zero.ZrFontSizeNano}/18px ${zero.ZrFontFamilyDigitalLight};                
        
        margin: 0;
        color: ${zero.ZrColorNeutralMedium02};                       
    }       

    @media screen and (min-width: ${Breakpoints.menu}){
        font-size: ${zero.ZrFontSizeMicro};
        height: 100%;

        h6 {        
            font-size: ${zero.ZrFontSizeXxxs};        
        }  
    }
`

export const ImageBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 31px;
    margin-right: ${zero.ZrSpacingHorizontalNano};    
`
